import React, { useState, useEffect } from 'react';
import './scss/App.scss';
import logo from './img/logo-sts.svg';
import SupportWidget from './SupportWidget';
import doodleBg from './img/doodles-support-bg.webp';
import SuccessPopup from './SuccessPopup';
import Loader from './Loader';
import { toast, ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';
import RotatingText from './components/RotatingText';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function STSForm() {
  const [form, setForm] = useState({
    brand: '', model: '', serial: '', issue: '',
    serviceType: '', machineId: '', scheduleDate: null
  });

  const [loading, setLoading] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [user, setUser] = useState({});
  const [types, setTypes] = useState([]);
  const [userMachines, setUserMachines] = useState([]);
  const [useSavedMachine, setUseSavedMachine] = useState(false);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);

  useEffect(() => {
    fetch('/core/check-session.php', { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (!data.loggedIn) {
          window.location.href = '/';
          return;
        }
        setUser(data);
        fetch('/api/php/get-user-machines.php', { credentials: 'include' })
          .then(res => res.json())
          .then(setUserMachines);
      });

    fetch('/api/php/get-service-types.php')
      .then(res => res.json())
      .then(setTypes);

    fetch('/api/php/get-machine-brands.php')
      .then(res => res.json())
      .then(setBrands);

    fetch('/api/php/get-models-by-brand.php')
      .then(res => res.json())
      .then(setModels);
  }, []);

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: 'Are you sure you want to log out?',
      text: 'You will need to sign in again to continue.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, log out',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#aaa'
    });

    if (result.isConfirmed) {
      window.location.href = '/core/logout.php';
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleBrandChange = (e) => {
    const selectedBrandId = e.target.value;
    setForm(prev => ({ ...prev, brand: selectedBrandId, model: '' }));
    fetch(`/api/php/get-models-by-brand.php?brand=${selectedBrandId}`)
      .then(res => res.json())
      .then(setModels);
  };

  const handleModelChange = (e) => {
    const selectedModelId = e.target.value;
    const selectedModel = models.find(m => m.id_machine_model === selectedModelId);
    setForm(prev => ({
      ...prev,
      model: selectedModelId,
      brand: selectedModel?.id_brand || prev.brand
    }));
  };

  const handleSelectMachine = (e) => {
    const selectedId = parseInt(e.target.value);
    const machine = userMachines.find(m => parseInt(m.id_machine) === selectedId);
    if (machine) {
      setForm(prev => ({
        ...prev,
        brand: machine.id_brand,
        model: machine.id_machine_model,
        serial: machine.machine_serial,
        machineId: machine.id_machine
      }));
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to send this request?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, send it!',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#002255',
    cancelButtonColor: '#aaa'
  });

  if (!result.isConfirmed) return;

  setLoading(true);

  try {
    const res = await fetch('/api/php/insert-service-request.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        serviceType: form.serviceType,
        serial: form.serial,
        issue: form.issue,
        scheduleDate: form.scheduleDate,
        machineModelId: form.model,
        brandId: form.brand,
        userMachineId: useSavedMachine ? form.machineId : null
      })
    });

    const data = await res.json();
    setLoading(false);

    if (data.success) {
      toast.success('✅ Request sent!');
      setPopupVisible(true);

      // Limpiar formulario
      setForm({
        brand: '',
        model: '',
        serial: '',
        issue: '',
        serviceType: '',
        machineId: '',
        scheduleDate: null
      });
      setUseSavedMachine(false);

      // Ejecutar webhook solo si existe id_requisition
      if (data.id_requisition) {
        await fetch('/api/php/send_service_requisition_webhook.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ id_requisition: data.id_requisition })
        });
      } else {
        console.warn('id_requisition not returned in response');
      }
    } else {
      toast.error(`❌ Failed to send request. ${data.error || 'Unknown error.'}`);
    }
  } catch (error) {
    setLoading(false);
    toast.error(`❌ Request failed. ${error.message}`);
    console.error('Request Error:', error);
  }
};



  return (
    <div className="form-wrapper" style={{ backgroundImage: `url(${doodleBg})` }}>
      <ToastContainer position="top-right" autoClose={2500} hideProgressBar theme="colored" />

      <div className="form-container">
        <div className="logout-container">
          <button className="logout-btn" onClick={handleLogout}>Logout</button>
        </div>

        <img src={logo} alt="STS Logo" className="form-logo" />

        <div className="rotating-container">
          <span style={{ color: '#000' }}>Solucinde</span>
          <RotatingText
            texts={['Support', 'Maintenance', 'Training']}
            splitBy="words"
            mainClassName=""
            splitLevelClassName="rotating-highlight"
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "-120%", opacity: 0 }}
            staggerDuration={0.025}
            transition={{ type: "spring", damping: 30, stiffness: 400 }}
            rotationInterval={2500}
            animatePresenceMode="wait"
            animatePresenceInitial={false}
          />
        </div>

        <p className="form-description">Please fill the next form to proceed with your request.</p>

        <form onSubmit={handleSubmit}>
          <div className="contact-box">
            <h4><i className="fas fa-address-card"></i> Contact Info</h4>
            <div className="info-line">👤 Name: {user.name} {user.last_name}</div>
            <div className="info-line">📧 Email: {user.email}</div>
            <div className="info-line">📞 Phone: {user.phone_number || '—'}</div>
            <div className="info-line">🏢 Company: {user.company || '—'}</div>
          </div>

          <h4 className="section-title">⚙️ Machine Info</h4>
          <div className="mb-2">
            <label><input type="checkbox" checked={useSavedMachine} onChange={() => setUseSavedMachine(prev => !prev)} /> Use My Registered Machine</label>
          </div>

          {useSavedMachine ? (
            <select onChange={handleSelectMachine} required>
              <option value="">Select Your Machine</option>
              {userMachines.map(machine => (
                <option key={machine.id_machine} value={machine.id_machine}>
                  {machine.brand_name} - {machine.machine_model} - SN: {machine.machine_serial} {machine.alias && `(${machine.alias})`}
                </option>
              ))}
            </select>
          ) : (
            <>
              <select name="brand" value={form.brand} onChange={handleBrandChange} required>
                <option value="">Select Brand</option>
                {brands.map(b => (
                  <option key={b.id_brand} value={b.id_brand}>{b.brand_name}</option>
                ))}
              </select>

              <select name="model" value={form.model} onChange={handleModelChange} required>
                <option value="">Select Model</option>
                {models.map(m => (
                  <option key={m.id_machine_model} value={m.id_machine_model}>{m.machine_model}</option>
                ))}
              </select>

              <input name="serial" placeholder="Machine Serial Number" value={form.serial} onChange={handleChange} required />
            </>
          )}

          <select name="serviceType" value={form.serviceType} onChange={handleChange} required>
            <option value="">Type of Service</option>
            {types.map(type => (
              <option key={type.id_service_type} value={type.id_service_type}>{type.name}</option>
            ))}
          </select>

          {form.serviceType === '4' && (
            <div className="calendar-container">
              <label>Select Preferred Date</label>
              <DatePicker
                selected={form.scheduleDate}
                onChange={(date) => setForm({ ...form, scheduleDate: date })}
                dateFormat="yyyy-MM-dd"
                minDate={new Date()}
                required
              />
            </div>
          )}

          <textarea name="issue" placeholder="Details of your service" value={form.issue} onChange={handleChange} required></textarea>
          <button type="submit" disabled={loading}>Send request</button>
        </form>

        <SupportWidget />
      </div>

      {loading && <Loader />}
      <SuccessPopup show={popupVisible} onClose={() => setPopupVisible(false)} />
    </div>
  );
}

export default STSForm;
